import { PropsWithChildren } from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '../lib';

type Props = PropsWithChildren<{
  className?: string;
  size?: 'base' | 'large';
}>;

const variants = cva('w-full max-w-[350px] mt-10 pb-[174px]', {
  variants: {
    size: {
      base: 'max-w-[350px]',
      large: 'max-w-[500px]',
    },
  },
});

export const StepBody = ({ children, className, size = 'base' }: Props) => {
  return <div className={cn(variants({ size }), className)}>{children}</div>;
};
